import React from 'react';
import PropTypes from 'prop-types';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import StudentStudyQualityGauge from './StudentStudyQualityGauge';
import { StudentStudyQualityListService } from '../../services/CustomerSuccessKpiListService';
import CustomerSuccessHistoryService from '../../services/CustomerSuccessHistoryService';

class StudentStudyQualityCompanyGaugeContainer extends React.Component {
  static propTypes = {
    companyId: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);
    StudentStudyQualityListService.load();
  }

  render() {
    const data = toJS(StudentStudyQualityListService.getByCompanyId(this.props.companyId));
    return (
      <StudentStudyQualityGauge
        loading={
          StudentStudyQualityListService.fetchCurrent.fetching || StudentStudyQualityListService.fetchPrevious.fetching
        }
        currentValue={data.current}
        previousValue={data.previous}
        onClickHistory={() => CustomerSuccessHistoryService.openDialog('STUDENT_STUDY_QUALITY', this.props.companyId)}
        formatter={StudentStudyQualityListService.getFormattedValue}
      />
    );
  }
}

export default observer(StudentStudyQualityCompanyGaugeContainer);
